var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contact_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 26 26",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("g", {
    id: "contact_svg__Franz"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact_svg__Group-Copy",
    transform: "translate(-180 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact_svg__menu-contacts",
    transform: "translate(181.5 12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M20.8 20.4H2.2c-1.4 0-2.6-1.2-2.6-2.6V6.2c0-1.4 1.2-2.6 2.6-2.6h18.5c1.4 0 2.6 1.2 2.6 2.6v11.6c.1 1.4-1.1 2.6-2.5 2.6zM2.2 4.8c-.8 0-1.4.6-1.4 1.4v11.6c0 .8.6 1.4 1.4 1.4h18.5c.8 0 1.4-.6 1.4-1.4V6.2c0-.8-.6-1.4-1.4-1.4H2.2z",
    id: "contact_svg__Rectangle-Copy-9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M11.7 14c-.5 0-1.1-.2-1.5-.5l-7-5.2c-.2-.2-.3-.6-.1-.8.2-.3.6-.3.8-.1l7 5.2c.5.4 1.2.4 1.7 0l7-5.2c.3-.2.6-.1.8.1.2.3.1.6-.1.8l-7 5.2c-.5.3-1 .5-1.6.5z",
    id: "contact_svg__Path-4-Copy"
  })))));
}
export default SvgContact;